import React, { useState } from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { makeStyles } from "@material-ui/core/styles";
import userIcon from "../../images/user-icon.svg";
import useUserState from "../hooks/useUserState";
import Axios from "axios";
import VaccinesDialog from "./VaccinesDialog";
import useBDocTranslator from "../hooks/useBDocTranslator";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    boxShadow: theme.shadows[8],
    padding: theme.spacing(4),
    width: "90%",
    maxWidth: 720,
    maxHeight: "90vh",
    overflowY: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& img": {
      width: 32,
      height: 32,
      marginRight: theme.spacing(1.5),
    },
    "& h3": {
      margin: 0,
      fontSize: "1.125rem",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
  },
}));

export default function VaccinesModalForm(props) {
  const classes = useStyles();
  const [responseMessage, setResponseMessage] = useState("");
  const userLocalState = useUserState();
  const [successFlag, setSuccessFlag] = useState(false);
  const { t } = useBDocTranslator();

  //Method creates a dependant
  const handleVaccinesCreate = (data) => {
    if (!validateData(data)) {
      setResponseMessage("Error, Please fill the Form");
      return;
    }

    Axios.post(`${process.env.REACT_APP_API_URL_BASE}/ehr/create`, data, {
      headers: { Authorization: "Bearer " + userLocalState[0].jwt },
    })
      .then((response) => {
        setSuccessFlag(true);
        setResponseMessage("Vaccine created, EHR Updated");
        props.handleRefreshData();
      })
      .catch((error) => {
        console.log(error);
        setResponseMessage(error);
      });
  };

  // validate the data object if it is valid
  const validateData = (data) => {
    if (data.name === "") {
      return false;
    }
    if (data.application_date === "") {
      return false;
    }
    if (data.dose < 1) {
      return false;
    }
    if (data.batch === "") {
      return false;
    } else {
      return true;
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={props.handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          {
            <div className={classes.paper}>
              <div className={classes.header}>
                <img src={userIcon} alt="vaccines icon" />
                <h3>{t("Include Vaccines")}</h3>
              </div>
              {responseMessage && (
                <p
                  className={`font-weight-bold text-center ${
                    responseMessage.includes("Error") ? "text-danger" : "text-success"
                  }`}
                  style={{ marginBottom: "12px" }}
                >
                  {t(responseMessage)}
                </p>
              )}
              {/* Form */}
              <div>
                <VaccinesDialog
                  handleVaccinesCreate={handleVaccinesCreate}
                  // prescriptionValue={notes}
                  // handleSave={handlePrescriptionSave}
                  handleClose={props.handleClose}
                  successFlag={successFlag}
                  patientId={props.patientId}
                />
              </div>
            </div>
          }
        </Fade>
      </Modal>
    </div>
  );
}
